import React from 'react'
import PropTypes from 'prop-types'

const Field = ({ label, value }) => {
  return (
    <div className='mb-3 row'>
      <div className='col-12'>
        <span className='text-muted h6 pe-2'>{label}</span>
        {value}
      </div>
    </div>
  )
}

Field.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
}

export default Field
